// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<path d="M0,14 L0,11.984375 L16,11.984375 L16,14 L0,14 Z M0,8.984375 L0,7.015625 L16,
				7.015625 L16,8.984375 L0,8.984375 Z M0,2 L16,2 L16,4.015625 L0,4.015625 L0,2 Z" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Menu.js